/**
 * Best-effort "is the admin on a phone right now?" check, used to decide whether
 * the Impersonate dialog should offer a tappable deep link (mobile) or a QR code
 * to scan from a separate phone (desktop).
 */
export function isMobileDevice(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const coarsePointer =
    typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;

  const mobileUa = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '');

  const narrowViewport = window.innerWidth > 0 && window.innerWidth <= 820;

  return (coarsePointer && mobileUa) || (mobileUa && narrowViewport);
}
